import styled from 'styled-components';

export const AdminPageWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 600px;
  height: 100%;
`;

export const AdminPanelWrapper = styled.div`
  height: 100%;
  border: 1px solid grey;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
